<template lang="html">
  <i-modal
    width="450"
    :value="isShowed"
    @on-visible-change="changeHandler"
    class-name="vertical-center-modal">
    <div class="header" slot="header" :class="{'more-m-b': selected === 1}">
      <span v-show="selected === 0">登录/注册斐艺</span>
      <span  v-show="selected === 1">打开微信，扫码登录</span>
    </div>
    <div class="content">
      <!-- login form -->
      <i-form ref="loginForm"
              class="login"
              :model="loginForm"
              :show-message="false"
              v-show="selected === 0"
              :rules="loginRules">
        <i-form-item class="mobile" prop="mobile">
          <i-input v-model.trim.number="loginForm.mobile" placeholder="请输入手机号码">
            <i-icon slot="prefix" custom="fy-icon-phone"></i-icon>
            <i-select v-model="loginForm.mobile_code" slot="prepend" style="width: 120px">
              <i-option :value="mobileCode.code" v-for="(mobileCode, index) in mobileCodeArr" :label="`+${mobileCode.code}`" :key="index">+{{mobileCode.code}} {{mobileCode.name}}</i-option>
            </i-select>
          </i-input>
          <i-divider></i-divider>
        </i-form-item>
        <i-form-item class="code" prop="code">
          <div class="sms-code-wrap">
            <i-input class="input-sms-code" v-model.trim="loginForm.code" placeholder="请输入验证码">
              <i-icon slot="prefix" custom="fy-icon-code"></i-icon>
            </i-input>
            <i-button class="send-code-btn" @click="fetchCode" type="primary" ghost :disabled="isCodeBtnDisabled">{{ codeBtnLabel }}</i-button>
          </div>
          <i-divider></i-divider>
        </i-form-item>
        <i-form-item class="protocol">
          <i-checkbox v-model="isAgree">使用手机号登录/注册斐艺平台，表示您已阅读且同意遵守<a class="link-protocol" href="index.html#/protocol" target="_blank">《斐艺平台用户协议》</a></i-checkbox>
        </i-form-item>
        <div class="login-btn-wrap text-center">
          <i-button class="login-btn" type="primary" @click="login"><i-icon custom="fy-icon-nextstep"></i-icon></i-button>
        </div>
        <div class="wx-login-wrap text-center">
          <i-button class="wx-login-btn" type="text" @click="showForm(1)">
            <img class="wx-icon" src="../assets/icon-wechat.png" width="28" height="28" />
            <span class="label">微信扫码登录</span>
          </i-button>
        </div>
      </i-form>
      <!-- Scan QR -->
      <div class="scan-qr text-center" v-show="selected === 1">
        <div class="qr-img-wrap text-center">
          <div id="qr-login" class="qr-login" v-show="!isQRTimeout"></div>
          <div class="invalid-tip" v-show="isQRTimeout">
            <p>二维码已失效</p>
            <i-button type="text" slot="append" @click="refreshQR"><i-icon type="ios-sync"/>点击刷新</i-button>
          </div>
        </div>
        <div class="tip">使用功能前，请先将斐艺账号与微信绑定
绑定流程：短信验证码登录-会员中心-设置-绑定微信</div>
        <div class="go-back-btn" @click="showForm(0)">
          <div class="icon-mes"></div>
          <div class="go-to-login-btn">使用验证码登录</div>
        </div>
      </div>
    </div>
    <div class="footer" slot="footer"></div>
  </i-modal>
</template>

<script>
import { Modal, Form, FormItem, Input, Checkbox, Icon, Divider, Select, Option } from 'iview'

import api from 'modules/member/api'

import * as MSG from 'assets/data/message.js'
import { mapActions } from 'vuex'

import { getQuery } from '@/common/js/utils.js'
import { fetchScriptFile } from '@/common/js/loadScript.js'
import { WX_QR_URL, WX_APP_ID, WX_GETTING_CODE_INTERVAL, WX_GETTING_CODE_TIMEOUT } from '@/assets/data/constants.js'

// 表单名称
const FORMS = ['login']

export default {
  data () {
    const mobileValidator = (rule, value, cb) => {
      if (!(/^\d{6,11}$/.test(value))) {
        cb(new Error('手机号格式不正确！'))
      } else {
        cb()
      }
    }
    const codeValidator = (rule, value, cb) => {
      if (!(/^\d{4,6}$/.test(value))) {
        cb(new Error('验证码格式不正确！'))
      } else {
        cb()
      }
    }
    return {
      // 当前选中表单的状态值：0(default) => 密码登录，1 => 扫码登录
      selected: 0,
      // 登录表单字段
      loginForm: {
        // 用户手机
        mobile: null,
        // 短信验证码
        code: '',
        // 国际区号
        mobile_code: 86
      },
      // 登录表单校验规则
      loginRules: {
        mobile: [{
          required: true,
          message: '手机号不可为空！'
        }, {
          // 使用定义的 mobileValidator 函数辅助对手机号码格式进行校验
          validator: mobileValidator
        }],
        code: [{
          required: true,
          message: '短信验证码不可为空！'
        }, {
          validator: codeValidator
        }]
      },
      isAgree: true,
      initCount: 60, // 获取短信验证码按钮初始冷却计数
      count: 60, // 获取短息验证码当前冷却计数
      counter: null, // 计数器
      isQRTimeout: false // 登录二维码是否失效
    }
  },
  destroyed () {
    this.stopCount() // 停止当前获取验证码冷却的计数器
    this.clearQrTimer() // 停止当前计算微信扫码登录二维码有效期计时器
  },
  model: {
    prop: 'isShowed',
    event: 'change'
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCodeBtnDisabled () {
      return this.count < 60
    },
    codeBtnLabel () {
      // 当计时器工作时，即获取短信验证码处于冷却中，显示当前计数
      return this.isCodeBtnDisabled ? `${this.count}s` : '获取验证码'
    },
    mobileCodeArr () {
      return this.$store.state.mobileCode
    }
  },
  watch: {
    isShowed (newVal) {
      // Reset selected status, default to select login form.
      if (newVal) {
        this.$nextTick(() => {
          this.selected = 0
        })
      }
    },
    // 选中表单后，重置字段并移除已经校验的结果
    selected (newVal, oldVal) {
      this.stopCount()
      // 微信扫码登录无需重置表单
      if (newVal === 1 || oldVal === 1) return
      // 重置前一个表单
      this.$refs[`${FORMS[oldVal]}Form`].resetFields()
      this.$nextTick(() => {
        // 重置选中表单
        this.$refs[`${FORMS[newVal]}Form`].resetFields()
      })
    }
  },
  methods: {
    ...mapActions('member', ['fetchAccountProfile']),
    changeHandler (isShowed) {
      this.$emit('change', isShowed)
    },
    // 清除二维码定时器
    clearQrTimer () {
      this.timerId && clearInterval(this.timerId)
      this.timerId = null
    },
    // 开启间隔获取url上的code计时器
    startGettingCode () {
      this.qrTimeout = WX_GETTING_CODE_TIMEOUT
      this.timerId = setInterval(async () => {
        this.qrTimeout -= WX_GETTING_CODE_INTERVAL
        const code = getQuery('code')
        if (code) {
          const vm = this
          // 发送扫码登录请求
          await this.$store.dispatch('qrLogin', {
            code,
            cb () { vm.$emit('change', false) } // 关闭登录模态弹框
          })
          this.clearQrTimer()
        }
        if (this.qrTimeout <= 0) {
          this.isQRTimeout = true
        }
      }, WX_GETTING_CODE_INTERVAL)
    },
    // 刷新微信绑定二维码
    refreshQR () {
      this.createQr()
    },
    // 创建微信二维码
    async createQr () {
      const WxLogin = this.WxLogin || await fetchScriptFile(WX_QR_URL, 'WxLogin')
      const currentUri = window.location
      // 将当前二维码置为有效，显示二维码。
      this.isQRTimeout = false
      this.$nextTick(() => {
        /* eslint-disable no-unused-vars */
        const qrObj = new WxLogin({
          id: 'qr-login',
          appid: WX_APP_ID,
          scope: 'snsapi_login',
          href: 'https://static.xmfineart.com/static/wx-qr-style.css',
          redirect_uri: encodeURIComponent(currentUri)
        })
        // 开始二维码扫码计时
        this.startGettingCode()
      })
    },
    showForm (index) {
      this.selected = Number.parseInt(index)
      // wx 扫码登录
      if (index === 1) {
        this.isQRTimeout = true
        this.$nextTick(() => {
          this.createQr()
        })
      } else {
        this.clearQrTimer()
      }
    },
    startCount () {
      this.counter = setInterval(() => {
        --this.count
        if (this.count <= 0) {
          this.stopCount()
        }
      }, 1000)
    },
    stopCount () {
      this.count = this.initCount
      clearInterval(this.counter)
    },
    // 获取短信验证码
    fetchCode () {
      const cb = async (result) => {
        if (!result) {
          let mobile = `${this.loginForm.mobile_code}-${this.loginForm.mobile}`
          const response = await api.fetchCode({ type: 207, mobile_full: mobile })
          if (response.code === 200) {
            this.$store.commit('ADD_MESSAGE', { msg: MSG['SEND_CODE_SUCCESS'], type: 'success' })
            this.startCount()
          }
        } else {
          this.$store.commit('ADD_MESSAGE', { msg: result, type: 'error' })
        }
      }
      this.$refs.loginForm.validateField('mobile', cb)
    },
    // 提交登录表单
    async login () {
      if (!this.isAgree) {
        this.$store.commit('ADD_MESSAGE', { msg: MSG['ACCOUNT_REGISTER_AGREE_TIP'], type: 'error' })
        return false
      }
      const vm = this
      const result = await this.$refs.loginForm.validate()
      if (result) {
        this.$store.dispatch('login', {
          data: this.loginForm,
          cb () {
            vm.$emit('change', false) // 关闭登录模态弹框
            // vm.fetchAccountProfile() // 登录成触发获取用户信息事件
          }
        })
      } else {
        let mobileReg = /^\d{6,11}$/
        let codeReg = /^\d{4,6}$/
        if (!(this.loginForm.mobile && this.loginForm.code)) {
          this.$store.commit('ADD_MESSAGE', { msg: MSG['REG_REQUIRE_ERROR'], type: 'error' })
        } else if (!mobileReg.test(this.loginForm.mobile)) {
          this.$store.commit('ADD_MESSAGE', { msg: MSG['REG_MOBILE_ERROR'], type: 'error' })
        } else if (!codeReg.test(this.loginForm.code)) {
          this.$store.commit('ADD_MESSAGE', { msg: MSG['REG_CODE_EMPTY'], type: 'error' })
        }
      }
    }
  },
  components: {
    'i-modal': Modal,
    'i-icon': Icon,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-input': Input,
    'i-checkbox': Checkbox,
    'i-divider': Divider,
    'i-select': Select,
    'i-option': Option
  }
}
</script>

<style lang="stylus">
.vertical-center-modal
  display: flex
  align-items: center
  justify-content: center
  .ivu-modal
    top: 0
    .ivu-modal-content
      width: 100%
      height: 505px
      padding: 20px 27px 32px
      .ivu-modal-close .ivu-icon-ios-close
        font-size: 40px
        padding: 0
        right: -8px
        top: -12px
      .ivu-modal-header
        border-bottom: 0
        padding: 0
        .header
          text-style: 22px 500 #333 30px
          text-align: center
          margin: 28px 0 53px
          &.more-m-b
            margin-bottom: 59px
      .ivu-modal-body
        padding: 0
        .content
          padding: 0 20px
          overflow: hidden
          .ivu-form-item
            margin-bottom: 17px
            &.mobile
              .ivu-input-wrapper
                .ivu-input
                  padding-left: 14px
            .ivu-divider
              margin: 0
              background-color: #e5e5e5
            .ivu-input-wrapper
              padding: 12px 0
              .ivu-input
                padding: 4px 12px 4px 50px
                height: 30px
                font-size: 16px
                color: $black
                border: 0
                &:focus
                  box-shadow: none
              .ivu-input-prefix
                height: 30px
                top: 12px
                i
                  font-size: 22px
                  height: 30px
                  line-height: 30px
              .ivu-input-group-prepend
                border: none
              .ivu-select
                .ivu-select-selection
                  padding-left: 30px
                  height: 30px
                  border: none
                  background-color: $white
                  &:after
                    content: ''
                    absolute: top 50% right
                    width: 1px
                    height: 16px
                    transform: translateY(-50%)
                    background-color: #e5e5e5
                  .ivu-select-selected-value
                    height: 30px
                    line-height: 30px
                  .ivu-select-placeholder
                    height: 30px
                    line-height: 30px
            .ivu-form-item-error-tip
              padding: 0
              font-size: 14px
              margin-top: 10px
          .sms-code-wrap
            font-size: 0
            .send-code-btn
              position: absolute
              top: 12px
              right: 0
              width: 100px
              height: 30px
              font-size: 14px
              padding: 0 10px
              text-align: center
          /* login form */
          .login
            .code
              .ivu-divider
                min-width: 210px
                width: 210px
            .login-btn-wrap
              margin-top: 20px
              .login-btn
                width: 350px
                height: 54px
                box-shadow: 0 4px 12px rgba(247,181,44,0.5)
                .fy-icon-nextstep
                  font-size: 32px
            .wx-login-wrap
              margin-top: 20px
              .wx-login-btn:focus
                box-shadow: none
              .wx-login-btn
                padding: 0
              .ivu-btn>span
                display: inline-block
                font-size: 0
                .wx-icon
                  display: inline-block
                  vertical-align: middle
                  margin-right: 10px
                .label
                  display: inline-block
                  vertical-align: middle
                  font-size: 16px
                  line-height: 22px
                  color: $black1
            .protocol
              margin-top: 40px
              margin-bottom: 0
              .ivu-checkbox-wrapper
                text-style: 14px 400 #999 24px
                margin: 0
                .ivu-checkbox
                  top: -2px
                  .ivu-checkbox-inner
                    width: 16px
                    height: 16px
                    margin-right: 2px
                    border-radius: 50%
                    &:after
                      top: 2px
                      left: 5px
              .link-protocol
                color: #333
          .scan-qr
            .qr-img-wrap
              font-size: 0
              height: 246px !important
              .qr-login
                pointer-events: none
              .invalid-tip
                width: 100%
                text-align: center
                padding-top: 100px
                font-size: 18px
                color: $grey-high
                .ivu-btn-text
                  color: $black1
                  font-size: 20px
                  margin-top: 10px
                  &:focus
                    box-shadow: none
                  &:hover
                    background-color: transparent
          .tip
            text-style: 14px 400 #999 20px
            margin: 0 auto 22px
            text-align: center
            white-space: pre
          .go-back-btn
            flex-space-center()
            cursor: pointer
            .icon-mes
              bg-icon(28px, 28px, '../assets/icon-mes.png')
              margin-right: 10px
            .go-to-login-btn
              font-size: 16px
              line-height: 22px;
              color: $orange
              padding: 0
              text-align: center
      .ivu-modal-footer
        padding: 0
</style>



// WEBPACK FOOTER //
// src/components/LoginRegisterModal.vue